import { Observable } from "rxjs";

export default class MapControlLayer {
    constructor(id, dataStream, selectionDataStream, linkedHideable = null) {
        this.id = id;
        this.dataStream = dataStream;
        this.selectionDataStream = selectionDataStream;
        this.visible = true;

        this.dataStream.observe().subscribe((mapElements) => {
            if (this.subscriber) {
                this.subscriber.next({
                    mapElements: mapElements,
                    visible: this.visible
                });
            }
        });

        this.dataStream.observeSelection().subscribe((mapElements) => {
            if (this.selectionDataStream) {
                this.selectionDataStream.setMapElements(mapElements);
            }
        });

        if (linkedHideable) {
            linkedHideable.observe().subscribe((fieldInfo) => {
                if (fieldInfo.field == "hidden") {
                    const hidden = fieldInfo.value;
                    this.visible = !hidden;

                    if (this.subscriber) {
                        this.subscriber.next({
                            mapElements: this.dataStream.visibleMapElements,
                            visible: this.visible
                        });
                    }
                }
            });
        }
    }

    observe() {
        const observable = new Observable((subscriber) => {
            this.subscriber = subscriber;
            this.subscriber.next({
                mapElements: this.dataStream.visibleMapElements,
                visible: this.visible
            });
        });
        return observable;
    }

    _zoomStopProperty(zoomStop, propertyName) {
		const roundedZoomStop = Math.ceil(zoomStop * 100.0);
		var property = "stop_" + roundedZoomStop + "_";
		property = property.replace(",", ".").replace(".", "_");
		return property + propertyName;
	}
}